// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-n_hu","advertDetailService__price":"c-n_hv"};